module.exports = __webpack_public_path__ + "static/004-62523d319f0782db471ccd2e55a5fee9.png";